package com.hyperether.goodjob.scenes.user

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.requiredHeight
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.wrapContentWidth
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.Divider
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.navigation.NavHostController
import com.hyperether.goodjob.boxCornerShape
import com.hyperether.goodjob.itemDetailsMargin
import com.hyperether.goodjob.itemDetailsMenuMargin
import com.hyperether.goodjob.models.User
import com.hyperether.goodjob.navigation.AddNewUser
import com.hyperether.goodjob.navigation.Users
import com.hyperether.goodjob.repository.remote.model.WorkingHours
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.address
import com.hyperether.goodjob.resources.briefcase_unselect
import com.hyperether.goodjob.resources.building
import com.hyperether.goodjob.resources.city
import com.hyperether.goodjob.resources.country
import com.hyperether.goodjob.resources.details
import com.hyperether.goodjob.resources.edit
import com.hyperether.goodjob.resources.email_capital
import com.hyperether.goodjob.resources.error
import com.hyperether.goodjob.resources.error_message
import com.hyperether.goodjob.resources.full_name
import com.hyperether.goodjob.resources.ic_leave
import com.hyperether.goodjob.resources.ic_mail
import com.hyperether.goodjob.resources.ic_map_pin
import com.hyperether.goodjob.resources.ic_skills
import com.hyperether.goodjob.resources.ic_user
import com.hyperether.goodjob.resources.ic_users
import com.hyperether.goodjob.resources.ic_work_scheduler
import com.hyperether.goodjob.resources.no_dates_selected
import com.hyperether.goodjob.resources.no_hours_available
import com.hyperether.goodjob.resources.no_information
import com.hyperether.goodjob.resources.not_assigned
import com.hyperether.goodjob.resources.phone
import com.hyperether.goodjob.resources.role
import com.hyperether.goodjob.resources.skills
import com.hyperether.goodjob.resources.status
import com.hyperether.goodjob.resources.teams
import com.hyperether.goodjob.resources.upcoming_leaves
import com.hyperether.goodjob.resources.work_schedule
import com.hyperether.goodjob.resources.world_2_svgrepo_com_1
import com.hyperether.goodjob.resources.zip
import com.hyperether.goodjob.scenes.components.DetailsDivider
import com.hyperether.goodjob.scenes.components.DetailsLeftMenuItem
import com.hyperether.goodjob.scenes.components.ErrorDialog
import com.hyperether.goodjob.scenes.components.ProfilePictureSection
import com.hyperether.goodjob.scenes.components.WebViewHeader
import com.hyperether.goodjob.scenes.components.clickableWithPointer
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.scenes.components.verticalScrollbar
import com.hyperether.goodjob.scenes.register.FullScreenProgressBar
import com.hyperether.goodjob.scenes.user.components.UserDailyActivities
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.BorderColor
import com.hyperether.goodjob.theme.DashboardBg
import com.hyperether.goodjob.theme.EmployeeDetailsText
import com.hyperether.goodjob.util.DateTimeUtil
import com.hyperether.goodjob.util.DateTimeUtil.formatWorkingHoursText
import com.hyperether.goodjob.util.DateTimeUtil.groupContiguousWorkingHours
import com.hyperether.goodjob.util.UserStatusHelper
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.goodjob.webDetailsTitle
import com.hyperether.resources.stringResource
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource
import org.lighthousegames.logging.logging

@Composable
fun UserDetailsScreenWeb(
    userId: String,
    viewModel: UserViewModel,
    navController: NavHostController,
    boxWidth: Dp
) {
    val log = logging("EmployeeDetails")
    val showProgressBar = remember { mutableStateOf(false) }
    val showErrorDialog = remember { mutableStateOf(false) }

    val focusManager = LocalFocusManager.current
    val focusRequester = FocusRequester()
    val selectedCard = remember { mutableStateOf(0) }
    val isEditView = remember { mutableStateOf(false) }

    val users by viewModel.users.collectAsState(emptyList())
    val user = remember(users) { users.find { it._id == userId } }

    LaunchedEffect(Unit) {
        viewModel.init()
    }

    val scrollState = rememberScrollState()
    Column(
        modifier = Modifier
            .fillMaxSize()
            .background(DashboardBg)
            .verticalScrollbar(scrollState)
            .verticalScroll(scrollState)
            .disableMouseDragScrollOnWeb()
    ) {
        WebViewHeader(
            isBackAvailable = true,
            title = user?.getName() ?: "",
            onBackClick = { navController.navigate(Users) },
            isImportAndAddVisible = false,
            navHostController = navController
        )

        // Form container
        Row(
            modifier = Modifier
                .padding(horizontal = 75.toScaleDp(), vertical = 15.toScaleDp())
                .fillMaxSize()
                .requiredHeight(height = 700.toScaleDp())
                .background(Color.White, shape = boxCornerShape())
                .border(
                    width = 1.toScaleDp(),
                    shape = boxCornerShape(),
                    color = BorderColor
                )
        ) {
            Column(
                modifier = Modifier
                    .width(210.toScaleDp())
                    .fillMaxHeight()
                    .padding(top = itemDetailsMenuMargin())
            ) {
                DetailsLeftMenuItem(
                    stringResource(Res.string.details),
                    selectedCard.value == 0,
                    onSelected = { selectedCard.value = 0 }
                )
            }
            DetailsDivider()
//            DetailsCards(
//                titles = listOf(
//                    stringResource(Res.string.details),
//                    //stringResource(Res.string.daily_activities)
//                ),
//                modifier = Modifier.width(210.toScaleDp()),
//                selectedCard = selectedCard
//            )
            Column(
                modifier = Modifier.fillMaxHeight().weight(5f)
            ) {
                if (selectedCard.value == 0) {
                    Row(
                        verticalAlignment = Alignment.Top,
                        modifier = Modifier
                            .height(webDetailsTitle())
                            .padding(itemDetailsMargin())
                    ) {
                        Text(
                            text = stringResource(Res.string.details),
                            fontSize = 27.toScaleSp(),
                            lineHeight = 30.toScaleSp(),
                            color = Color.Black,
                            fontWeight = FontWeight.W700,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                        Spacer(modifier = Modifier.weight(1f))
                        if (!viewModel.isEmployee()) {
                            Row(
                                modifier = Modifier.clickableWithPointer {
                                    navController.navigate(AddNewUser(user?._id ?: ""))
                                },
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Image(
                                    painter = painterResource(Res.drawable.edit),
                                    contentDescription = "",
                                    modifier = Modifier.padding(
                                        end = 16.toScaleDp()
                                    ).size(20.toScaleDp())
                                )
                                DisableSelection {
                                    Text(
                                        text = stringResource(Res.string.edit),
                                        fontSize = 18.toScaleSp(),
                                        fontWeight = FontWeight.Normal,
                                        maxLines = 1,
                                        overflow = TextOverflow.Ellipsis
                                    )
                                }
                            }
                        }
                    }
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(
                                start = itemDetailsMargin(),
                                end = itemDetailsMargin(),
                                bottom = itemDetailsMargin()
                            ),
                        horizontalArrangement = Arrangement.spacedBy(30.toScaleDp())
                    ) {
                        if (user != null) {
                            UserDetailsWeb(
                                user = user,
                                focusRequester = focusRequester,
                                modifier = Modifier.weight(4f)
                            )
                        }

                        val pictureSize = when {
                            boxWidth < 500.toScaleDp() -> 100.toScaleDp()
                            boxWidth < 700.toScaleDp() -> 140.toScaleDp()
                            boxWidth < 900.toScaleDp() -> 180.toScaleDp()
                            else -> 220.toScaleDp()
                        }
                        Row(
                            modifier = Modifier.weight(1f)
                        ) {
                            ProfilePictureSection(
                                user?.getName() ?: "",
                                modifier = Modifier
                                    .weight(1f)
                                    .width(pictureSize)
                                    .aspectRatio(1f)
                                    .wrapContentWidth(Alignment.End)
                            )
                        }
                    }
                } else {
                    UserDailyActivities(viewModel)
                }
            }
            Spacer(modifier = Modifier.height(20.toScaleDp()))
        }
    }
    if (showErrorDialog.value) {
        DisableSelection {
            val error = stringResource(Res.string.error)
            val message = stringResource(Res.string.error_message)
            ErrorDialog(
                onDismiss = {
                    showErrorDialog.value = false
                },
                title = error,
                message = message
            )
        }
    }
    if (showProgressBar.value) {
        DisableSelection {
            FullScreenProgressBar()
        }
    }
}


@Composable
fun UserDetailsWeb(
    user: User,
    focusRequester: FocusRequester,
    modifier: Modifier
) {
    Column(
        modifier = modifier,
    ) {
        LaunchedEffect(true) {
            focusRequester.requestFocus()
        }
        UserStatusRow(
            user = user,
            modifier = Modifier
        )
        Spacer(modifier = Modifier.height(24.toScaleDp()))
        UserCustomDisplayRow(
            painterResource = Res.drawable.ic_user,
            labelText = stringResource(Res.string.full_name),
            displayText = user.fullName ?: "",
            textColor = Color.Black,
            modifier = Modifier
        )
        Spacer(modifier = Modifier.height(24.toScaleDp()))
        UserCustomDisplayRow(
            painterResource = Res.drawable.briefcase_unselect,
            labelText = stringResource(Res.string.role),
            displayText = user.role ?: "",
            textColor = Color.Black,
            modifier = Modifier
        )
        Spacer(modifier = Modifier.height(24.toScaleDp()))
        UserCustomDisplayRow(
            painterResource = Res.drawable.phone,
            labelText = stringResource(Res.string.phone),
            displayText = user.phone ?: "",
            textColor = Color.Black,
            modifier = Modifier
        )
        Spacer(modifier = Modifier.height(24.toScaleDp()))
        UserCustomDisplayRow(
            painterResource = Res.drawable.ic_mail,
            labelText = stringResource(Res.string.email_capital),
            displayText = user.email ?: "",
            textColor = Color.Black,
            modifier = Modifier
        )
        Spacer(modifier = Modifier.height(16.toScaleDp()))
        UserCustomDisplayRow(
            painterResource = Res.drawable.building,
            labelText = stringResource(Res.string.city),
            displayText = user.city ?: "",
            textColor = Color.Black,
            modifier = Modifier
        )
        Spacer(modifier = Modifier.height(16.toScaleDp()))
        UserCustomDisplayRow(
            painterResource = Res.drawable.world_2_svgrepo_com_1,
            labelText = stringResource(Res.string.country),
            displayText = user.country ?: "",
            textColor = Color.Black,
            modifier = Modifier
        )
        Spacer(modifier = Modifier.height(16.toScaleDp()))
        UserCustomDisplayRow(
            painterResource = Res.drawable.ic_mail,
            labelText = stringResource(Res.string.zip),
            displayText = user.zip ?: "",
            textColor = Color.Black,
            modifier = Modifier
        )
        Spacer(modifier = Modifier.height(16.toScaleDp()))
        UserCustomDisplayRow(
            painterResource = Res.drawable.ic_map_pin,
            labelText = stringResource(Res.string.address),
            displayText = user.address ?: "",
            textColor = BlueApp,
            modifier = Modifier
        )
        Spacer(modifier = Modifier.height(24.toScaleDp()))
        Divider(
            modifier = Modifier.height(1.toScaleDp())
                .background(Color.LightGray.copy(alpha = 0.1f))
        )
        Spacer(modifier = Modifier.height(16.toScaleDp()))
        val teams = user.teams ?: emptyList()
        var teamEmployee = stringResource(Res.string.not_assigned)
        if (teams.isNotEmpty()) {
            teamEmployee = teams.joinToString(", ") { it?.value ?: "" }
        }
        var skillsEmployee = ""
        skillsEmployee = if (user.skills?.isNotEmpty() == true) {
            user.skills?.filter { it.isNotEmpty() }?.joinToString(", ")
                ?: stringResource(Res.string.not_assigned)

        } else {
            stringResource(Res.string.not_assigned)
        }
        val workingHours: WorkingHours? = user.workingHours
        val workingHoursText = workingHours?.let {
            val groupedSchedule = groupContiguousWorkingHours(it)
            formatWorkingHoursText(groupedSchedule)
        }
        val leaveString = if (user.upcomingLeave?.isNotEmpty() == true)
            DateTimeUtil.formatDateRange(user.upcomingLeave)
                ?: stringResource(Res.string.no_dates_selected)
        else
            stringResource(Res.string.no_dates_selected)
        UserCustomDisplayRow(
            painterResource = Res.drawable.ic_users,
            labelText = stringResource(Res.string.teams),
            displayText = teamEmployee,
            textColor = Color.Black,
            modifier = Modifier
        )
        Spacer(modifier = Modifier.height(16.toScaleDp()))
        UserCustomDisplayRow(
            painterResource = Res.drawable.ic_skills,
            labelText = stringResource(Res.string.skills),
            displayText = skillsEmployee,
            textColor = Color.Black,
            modifier = Modifier
        )
        Spacer(modifier = Modifier.height(16.toScaleDp()))
        UserCustomDisplayRow(
            painterResource = Res.drawable.ic_work_scheduler,
            labelText = stringResource(Res.string.work_schedule),
            displayText = if (workingHoursText?.isNotEmpty() == true) workingHoursText else stringResource(
                Res.string.no_hours_available
            ),
            textColor = Color.Black,
            modifier = Modifier
        )
        Spacer(modifier = Modifier.height(16.toScaleDp()))
        UserCustomDisplayRow(
            painterResource = Res.drawable.ic_leave,
            labelText = stringResource(Res.string.upcoming_leaves),
            displayText = leaveString,
            textColor = Color.Black,
            modifier = Modifier
        )
    }
}


@Composable
fun UserStatusRow(
    user: User,
    modifier: Modifier = Modifier,
    labelColor: Color = EmployeeDetailsText
) {
    Row(
        modifier = modifier
            .fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween
    ) {
        Text(
            text = stringResource(Res.string.status),
            color = labelColor,
            fontSize = 14.toScaleSp(),
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
        Text(
            modifier = Modifier
                .background(
                    shape = RoundedCornerShape(10.toScaleDp()),
                    color = UserStatusHelper.getStatusColor(
                        confirmStatus = user.confirmStatus,
                        status = user.status
                    )
                )
                .padding(horizontal = 13.toScaleDp(), vertical = 3.toScaleDp()),
            text = UserStatusHelper.getStatusText(
                confirmStatus = user.confirmStatus,
                status = user.status
            ),
            color = Color.White,
            fontSize = 14.toScaleSp(),
            lineHeight = 18.toScaleSp(),
            fontWeight = FontWeight.W500,
            textAlign = TextAlign.Center,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
    }
}

@Composable
fun UserCustomDisplayRow(
    painterResource: DrawableResource,
    labelText: String,
    displayText: String,
    modifier: Modifier = Modifier,
    textColor: Color,
    labelColor: Color = EmployeeDetailsText
) {
    Row(
        modifier = modifier
            .fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically
    ) {
        // Icon and Label
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.weight(1f)
        ) {
            Image(
                modifier = Modifier.size(20.toScaleDp()),
                painter = painterResource(painterResource),
                contentDescription = null
            )
            Text(
                text = labelText,
                color = labelColor,
                fontSize = 14.toScaleSp(),
                modifier = Modifier.padding(start = 20.toScaleDp()),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
        // Display Text
        Box(
            modifier = Modifier
                .weight(2f)
                .fillMaxWidth(),
            contentAlignment = Alignment.CenterEnd
        ) {
            Text(
                text = displayText.ifBlank { stringResource(Res.string.no_information) },
                color = textColor,
                fontSize = 14.toScaleSp(),
                fontWeight = FontWeight.Bold,
                textAlign = TextAlign.End,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
    }
}
